var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVcGame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.72222C1 3.11421 3.18883 1 5.88889 1H18.1111C20.8112 1 23 3.11421 23 5.72222C23 6.29947 22.6573 6.82557 22.1185 7.07536L21.5824 7.32392C19.6923 8.20025 19.6923 10.7998 21.5824 11.6761L22.1185 11.9246C22.6573 12.1744 23 12.7005 23 13.2778C23 15.8858 20.8112 18 18.1111 18H5.88889C3.18883 18 1 15.8858 1 13.2778C1 12.7005 1.34272 12.1744 1.88149 11.9246L2.41759 11.6761C4.30772 10.7998 4.30772 8.20025 2.41759 7.32391L1.88149 7.07536C1.34272 6.82557 1 6.29947 1 5.72222Z",
    stroke: "#27AE60",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9193 7.09595C11.2594 6.05135 12.7406 6.05135 13.0807 7.09595C13.2329 7.56311 13.6692 7.87941 14.1615 7.87941C15.2623 7.87941 15.72 9.28491 14.8294 9.93051C14.4311 10.2192 14.2645 10.731 14.4166 11.1982C14.7568 12.2428 13.5585 13.1114 12.6679 12.4658C12.2697 12.1771 11.7303 12.1771 11.3321 12.4658C10.4415 13.1114 9.24323 12.2428 9.5834 11.1982C9.73553 10.731 9.56888 10.2192 9.1706 9.93051C8.28003 9.28491 8.73772 7.87941 9.83853 7.87941C10.3308 7.87941 10.7671 7.56311 10.9193 7.09595Z",
    stroke: "#27AE60",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVcGame);
export default __webpack_public_path__ + "static/media/vc-game.41879f314f78394769137685a30eb351.svg";
export { ForwardRef as ReactComponent };